import DynamicFormDataFieldsCollapse from "./DynamicFormDataFieldsCollapse";



export default DynamicFormDataFieldsCollapse;
